import Image from 'next/image';
import NextLink from 'next/link';
import { useStoreMap, useUnit } from 'effector-react';

import { $cart, addedProductToCart, decrementProductAmount, incrementProductAmount } from '@/entities/cart';

import { Product } from '@/shared/api';
import { Button } from '@/shared/components/ui/button';
import { formatCurrency } from '@/shared/lib/currency';

interface ProductCardProps {
  product: Product;
}

export const ProductCard = (props: ProductCardProps) => {
  const { product } = props;

  const productFromCart = useStoreMap({
    store: $cart,
    keys: [product.id],
    fn: (cart, [productId]) => cart[productId] ?? null,
  });

  const { addToCart, incrementAmount, decrementAmount } = useUnit({
    addToCart: addedProductToCart,
    incrementAmount: incrementProductAmount,
    decrementAmount: decrementProductAmount,
  });

  return (
    <div className="rounded-sm">
      <NextLink href={`/products/${product.id}`} className="relative block aspect-[16/9] overflow-hidden rounded-md">
        <Image
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw, 50vw"
          src={product.images[0]}
          fill
          alt={product.title}
          className="object-cover"
        />
      </NextLink>
      <div>
        <h2 className="text-md line-clamp-1">
          <NextLink href={`/products/${product.id}`}>{product.title}</NextLink>
        </h2>

        <span className="text-md">{formatCurrency(product.price)}</span>
      </div>

      <div className="mt-4">
        {!productFromCart && (
          <Button className="w-full" onClick={() => addToCart(product)}>
            В корзину
          </Button>
        )}
        {productFromCart && (
          <div className="flex items-center">
            <Button className="flex-1" onClick={() => decrementAmount(product)}>
              -
            </Button>
            <div className="px-4 text-xl font-medium">{productFromCart.amount}</div>
            <Button className="flex-1" onClick={() => incrementAmount(product)}>
              +
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
